export default __webpack_public_path__ + "static/media/gothenburg_m1.91583583.png";